const env = {
  RECAPTCHA_PUBLIC_KEY: process.env.RECAPTCHA_PUBLIC_KEY as string,
  API_BASE_URL: process.env.API_BASE_URL as string,
  STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY as string,
  COOKIE_DOMAIN: process.env.COOKIE_DOMAIN as string,
  ACCESS_TOKEN_COOKIE_NAME: process.env.ACCESS_TOKEN_COOKIE_NAME as string,
  REFRESH_TOKEN_COOKIE_NAME: process.env.REFRESH_TOKEN_COOKIE_NAME as string,
  ORDER_PAGE_URL: process.env.ORDER_PAGE_URL as string,
  SITE_URL: process.env.SITE_URL as string,
  NODE_ENV: process.env.NODE_ENV as string,
  COPYRIGHT_YEAR: process.env.COPYRIGHT_YEAR as string,
  SENTRY_APPLICATION_TAG: process.env.SENTRY_APPLICATION_TAG as string,
} as const;

for (const [key, value] of Object.entries(env)) {
  if (!value) {
    throw new Error(`Environment variable ${key} is not set`);
  }
}

export default env;
